export enum SupportedBrowsers {
  CHROME = 'Chrome',
  MICROSOFT_EDGE = 'Microsoft Edge',
  FIREFOX = 'Firefox',
}
